import styled from "styled-components";
import { color } from "../../../../shared/styles";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

export const AssigneeBox = styled.div`
    padding: 14px 16px;
    border-radius: 12px;
    display: flex;
    width: 100%;
    background-color: ${color.emphasis.NEUTRAL_N0};
    box-sizing: border-box;
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .left {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .title {
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
            color: ${color.secondary.DARK_GREY};
        }

        .content {
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px;
            display: flex;
            flex-direction: column;
            gap: 8px;
            align-items: flex-start;
            padding: 6px 10px;
            border-radius: 8px;
            transition: background-color 120ms ease-in-out;

            .assignee-item {
                display: inline-flex;
                align-items: center;
                gap: 6px;
            }
            
            .assignee-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 16px;
                height: 16px;
                opacity: 0.8;
                
                svg {
                    width: 16px;
                    height: 16px;
                }
            }

            .assignee-text {
                display: inline-flex;
                align-items: baseline;
                gap: 6px;
            }

            .assignee-name {
                color: ${color.secondary.CHARCOAL};
            }

            .assignee-email {
                font-size: 12px;
                color: ${color.emphasis.NEUTRAL_N70};
            }

            &:hover {
                background-color: ${color.secondary.GREY_1};
            }
            
            &.locked:hover {
                background-color: transparent;
            }
            
            &.locked {
                cursor: default;
            }
        }
    }

    .right {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
`;

export const DropdownMenuContent = styled(DropdownMenu.Content)`
    background: ${color.emphasis.NEUTRAL_N0};
    border: 1px solid ${color.secondary.BORDER};
    border-radius: 10px;
    padding: 8px;
    z-index: 10000;
    box-shadow: 0 12px 28px rgba(0,0,0,0.12);
    min-width: max(260px, var(--radix-dropdown-menu-trigger-width));
    width: max(260px, var(--radix-dropdown-menu-trigger-width));
    max-height: 320px;
    overflow-y: auto;
    font-family: "Noto Sans";
`;

export const DropdownMenuItemTitle = styled(DropdownMenu.Item)`
    padding: 8px 10px;
    font-size: 12px;
    color: ${color.secondary.DARK_GREY};
    cursor: default;
    font-family: "Noto Sans";
`;

export const DropdownMenuSeparator = styled(DropdownMenu.Separator)`
    height: 1;
    background: ${color.secondary.BORDER};
    margin: 6px 0;
`;

export const DropdownMenuItemUnassigned = styled(DropdownMenu.Item)`
    padding: 8px 10px;
    font-size: 14px;
    cursor: pointer;
    border-radius: 6px;
    font-family: "Noto Sans";
    color: ${color.secondary.CHARCOAL};
`;

export const DropdownMenuItem = styled(DropdownMenu.Item)`
    padding: 8px 10px;
    font-size: 14px;
    cursor: pointer;
    border-radius: 6px;
    font-family: "Noto Sans";
    color: ${color.secondary.CHARCOAL};
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
